import { all, fork } from "redux-saga/effects";
import { loginWatcherSaga } from "../LoginState/LoginSaga";
import { userWatcherSaga } from "../UserState/UserSaga";
import {clientWatcherSaga } from "../ClientState/ClientSaga";
import { projectWatcherSaga } from "../ProjectState/ProjectSaga";
import {uploadFileWatcherSaga} from "../FileState/uploadFileSaga";
import { timeSheetWatcherSaga } from "../TimeSheetState/TimeSheetSaga";
import { profileWatcherSaga } from "../ProfileState/ProfileSaga";
import { empStatusWatcherSaga } from "../EmployeeStatusState/empStatusSaga";
import { reportsWatcherSaga } from "../ReportsState/ReportsSaga";
import { dashBoardWatcherSaga } from "../DashboardState/dashBoardSaga";
import { invoiceWatcherSaga } from "../InvoiceState/InvoiceSaga";
import { alertsWatcherSaga } from "../AlertsState/AlertsSaga";
import { timeOffWatcherSaga } from "../TimeOffState/TimeOffSaga";
export default function* rootSaga() {
  yield all([
    fork(loginWatcherSaga),
    fork(profileWatcherSaga),
    fork(userWatcherSaga),
    fork(clientWatcherSaga),
    fork(projectWatcherSaga),
    fork(uploadFileWatcherSaga),
    fork(timeSheetWatcherSaga),
    fork(empStatusWatcherSaga),
    fork(reportsWatcherSaga),
    fork(dashBoardWatcherSaga),
    fork(invoiceWatcherSaga),
    fork(alertsWatcherSaga),
    fork(timeOffWatcherSaga),
  ]);
}
